export default __webpack_public_path__ + "ce1a6e60dd2afbd8d84eb1dfcc3bf320.webp";